(() => {
  try {
    const fxRateAlertModal = document.getElementById("fxRateAlertModal");
    const alertIcon = document.getElementById("fxalertIcon")
  
    console.log("inFX Modal File")

    if (fxRateAlertModal && alertIcon) {

      //getting country and currency code from corridor hero block
      let senderCurrencyEle = document.querySelector(".reciver-currency-select-dropdown").getAttribute("data-currency");
      let senderCountryEle = document.querySelector(".reciver-currency-select-dropdown").getAttribute("data-country");
      let receiverCurrencyEle =document.querySelector("#default-receiver-currency-code").getAttribute("data-default-receiver-currency-name")
      let receiverCountryEle = document.querySelector(".reciver-currency-select-dropdown").getAttribute("data-reciver-country-code");
      let senderAmount = document.querySelector('.sender-amount').getAttribute('data-value')

      const amountInput = document.querySelector("#create-fx-alert-amount");
      const humanKeyEL = fxRateAlertModal.querySelector("#humanKey");
      const customAlertCheck = fxRateAlertModal.querySelector("#custom_alertCheck");
      const dailyRateCheckbox = fxRateAlertModal.querySelector("#dailyRateCheck");
      const submitButton = fxRateAlertModal.querySelector("#setAlert");
      let emailErrorText = fxRateAlertModal.querySelector('#create-fx-alert-email-error');
      let creatFxAlertSignUpEmailEl = fxRateAlertModal.querySelector("#createFXAlertFormEmailId")
      let amountInputErrorText = fxRateAlertModal.querySelector('#create-fx-alert-error-amount')

      let senderCountryCode = fxRateAlertModal.querySelector('.senderCountryCode')
      let receiverCountryCode = fxRateAlertModal.querySelectorAll('.receiverCountryCode')
      let senderCurrencyCode = fxRateAlertModal.querySelector('.senderCurrencyCode')
      let receiverCurrencyCode = fxRateAlertModal.querySelector('.receiverCurrencyCode')
      let fxAlertEmailId = fxRateAlertModal.querySelector(".fxAlertEmailId");
      let sendAmountDefault = fxRateAlertModal.querySelector('.senderAmount')
      let receiveAmt = fxRateAlertModal.querySelector('.receiverAmount')
      let sendCurrencyflagCode = fxRateAlertModal.querySelector('.wu-flag-alert-currency-code')


      senderCountryCode = senderCountryCode.classList.add(senderCountryEle.toLocaleLowerCase())
      senderCurrencyCode.textContent = senderCurrencyEle  
      Array.from(receiverCountryCode).forEach((receiverCode) => {
        receiverCode.classList.add(receiverCountryEle.toLocaleLowerCase())
      })
      receiverCurrencyCode.textContent = receiverCurrencyEle
      emailErrorText = emailErrorText && emailErrorText.innerText
      sendAmountDefault.textContent = "1.00"
      sendCurrencyflagCode = sendCurrencyflagCode.classList.add(senderCountryEle.toLocaleLowerCase())
    
      const fxAlertData = {};

      document.addEventListener('alertFxEvent', (event) => { // Output: { fx_amt: 19.52, strike_fx_amt: 30 }
        const fxData = event.detail;
        amountInput.value = fxData.fx_amt
        amountInput.setAttribute('value', amountInput.value)
        receiveAmt.textContent = fxData.fx_amt
        fxAlertData.payIn = fxData.payIn
        fxAlertData.payOut = fxData.payOut
        fxAlertData.threshold = fxData.fx_amt
      });

      const validateAmount = () => {
        amountInput.setAttribute('value', amountInput.value)
        let amount = amountInput.value;
        if (!amount || isNaN(amount) || amount <= 0) {
          amount = "";
          showValidationMessage(amountInput);
          console.log("Please enter a valid amount.");
          return false;
        } else {
          hideValidationMessage(amountInput);
          fxAlertData.amount = amount;
          return true;
        }
      };

      const validateRobotCheck = () => {
        const capatchValue = humanKeyEL.value;
        if(humanKeyEL){
          hideValidationMessage(humanKeyEL);
          if(capatchValue !== undefined  && capatchValue == ""){
            showValidationMessage(humanKeyEL);
            console.log("Please verify you are not a robot.");
            return false;
          }else{
            fxAlertData.captchaCheck = capatchValue;
            return true;
          }
        }
      }

      const validateDailyRateCheck = () => {
        if (!dailyRateCheckbox.checked) {
          console.log("Please select the daily exchange rate option.");
          return false;
        }
        fxAlertData.frequency = "DAILY"
        return true;
      }

      const validateCustomRateCheck = () => {
        if (!customAlertCheck.checked) {
          console.log("Please select the custom alert check option.");
          return false;
        }
        return true;
      }

      const validateEmailIdCheck = () => {
        creatFxAlertSignUpEmailEl.setAttribute('value', creatFxAlertSignUpEmailEl.value)
        if (creatFxAlertSignUpEmailEl) {
          hideValidationMessage(creatFxAlertSignUpEmailEl);
          let emailAddress = fxAlertEmailId.value;
          if (emailAddress !== undefined) {
            if (emailAddress == "") {
              showValidationMessage(creatFxAlertSignUpEmailEl);
              fxAlertEmailId.focus();
              return false;
            } else if (!emailAddress.match(mailformat)) {
                showValidationMessage(creatFxAlertSignUpEmailEl);
                fxAlertEmailId.focus();
                return false;
              } else {
                fxAlertData.emailAddress = emailAddress;
                return true;
            }
          }
        }
      }

      const callCreateFxAlertFormApi = (fxAlertData) => {
        const { country, lang } = getCountryAndLanguage();
        const isR4Country = getR4Country();
        if (isR4Country) {
          triggerRouterCreateSession(country, lang) //add create session api
            .then(({ sessionId, encryptedSessionId, clientIp, dataCenter }) => {
              if (sessionId) {
                triggerRouterCreateFxAlert(
                  sessionId,
                  country,
                  lang,
                  fxAlertData
                );
              }
            })
            .catch((error) => {
              console.error("Error from triggerRouterCreateSession : ", error);
            });
        } else {
          const responseObj = getCreateSessionR3API(country, lang); //add create session api
          responseObj
            .then((response) => {
              if (response?.sessionId) {
                triggerRouterCreateFxAlert(
                  sessionId,
                  country,
                  lang,
                  fxAlertData
                );
              }
            })
            .catch((error) => {
              console.error("Error from getCreateSessionR3API : ", error);
            });
        }
      };

      const validateForm = () => {
        const isAmountValid = validateAmount();
        const isRobotCheckValid = validateRobotCheck();
        const isDailyRateCheckValid = validateDailyRateCheck();
        const isSendMeAlertRateCheckValid = validateCustomRateCheck();
        const ischeckboxChecked = isSendMeAlertRateCheckValid || isDailyRateCheckValid
        const isEmailIdValid = validateEmailIdCheck();
        if (
          isAmountValid &&
          isRobotCheckValid &&
          ischeckboxChecked &&
          isEmailIdValid
        ) {

          fxAlertData.senderCountryCode = senderCountryEle.toUpperCase();
          fxAlertData.receiverCountryCode = receiverCountryEle;
          fxAlertData.senderCurrencyCode = senderCurrencyEle;
          fxAlertData.receiverCurrencyCode = receiverCurrencyEle;
          callCreateFxAlertFormApi(fxAlertData);
        }
      };
      const closeFxAlertModal = () => {
        fxRateAlertModal.classList.add('d-none')
        fxRateAlertModal.classList.remove('d-flex')
        hideValidationMessage(fxAlertEmailId)
        fxAlertEmailId.value = ""
       
      }

      window.openModal = () => {
        fxRateAlertModal.classList.remove('d-none')
        fxRateAlertModal.classList.add('d-flex')
      }
  
      fxRateAlertModal?.querySelector('.fxAlertClose')?.addEventListener('click', (event) => {
        closeFxAlertModal();
      });
  
      const initialize = () => {

        amountInput.addEventListener("input", (e) => {
          amountInput.setAttribute("value", amountInput.value);
          validateAmount();
        });

        creatFxAlertSignUpEmailEl.addEventListener("input", (e) => {
          creatFxAlertSignUpEmailEl.setAttribute("value", creatFxAlertSignUpEmailEl.value);
          validateEmailIdCheck();
        });

        submitButton.addEventListener("click", (e) => {
          e.preventDefault();
          validateForm();
        });

      }

      initialize();
    }
  } catch (e) {
    console.log("Error in create-fx-alert-form.js file");
  }
})()
